const BACKGROUND_MUSIC_KEY = '__background_music__';
let isInitialized = false;
let soundInstance: typeof import('@pixi/sound').sound | null = null;

async function getSound() {
  if (!soundInstance) {
    const { sound } = await import('@pixi/sound');
    soundInstance = sound;
  }
  return soundInstance;
}

export function useBackgroundMusic() {
  if (!import.meta.client) {
    return {
      initBackgroundMusic: () => {},
      destroyBackgroundMusic: () => {},
      get backgroundSound() {
        return undefined;
      }
    };
  }

  const store = useMainStore();

  const initBackgroundMusic = async () => {
    console.log('initBackgroundMusic...');
    if (isInitialized) return;

    console.log('1 check finished...');

    try {
      const sound = await getSound();

      if (!sound.exists(BACKGROUND_MUSIC_KEY)) {
        sound.add(BACKGROUND_MUSIC_KEY, '/sound/backgroundSound.mp3');
      }

      const backgroundSound = sound.find(BACKGROUND_MUSIC_KEY);
      if (backgroundSound) {
        backgroundSound.loop = true;
        backgroundSound.volume = store.volume.music;
        backgroundSound.play();
      }

      isInitialized = true;
    } catch (error) {
      console.error('Failed to initialize background music:', error);
    }
  };

  const destroyBackgroundMusic = async () => {
    try {
      const sound = await getSound();
      sound.find(BACKGROUND_MUSIC_KEY)?.stop();
      isInitialized = false;
    } catch (error) {
      console.error('Failed to destroy background music:', error);
    }
  };

  onMounted(() => {
    initBackgroundMusic();
  });

  onBeforeUnmount(() => {
    destroyBackgroundMusic();
  });

  watch(
    () => store.volume.music,
    async (newVolume) => {
      try {
        console.log({ newVolume });
        const sound = await getSound();
        const bg = sound.find(BACKGROUND_MUSIC_KEY);
        if (bg) {
          bg.volume = newVolume;
        }
      } catch (error) {
        console.error('Failed to update volume:', error);
      }
    }
  );

  return {
    initBackgroundMusic,
    destroyBackgroundMusic,
    async getBackgroundSound() {
      try {
        const sound = await getSound();
        return sound.find(BACKGROUND_MUSIC_KEY);
      } catch (error) {
        console.error('Failed to get background sound:', error);
        return undefined;
      }
    }
  };
}
